// 단순화된 LLM 클라이언트.
// 백엔드가 프롬프트·스냅샷·모델 호출·액션 디스패치를 모두 처리하므로,
// 프론트는 다음 엔드포인트만 호출:
//   POST /core-api/admin/ai/chat            { input, history, image_url? }  → plan 응답 (actions 배열)
//   POST /core-api/admin/ai/chat/execute    { actions:[{action,args}] }     → 실행 결과 (results 배열)
//   POST /core-api/admin/ai/upload          multipart file                  → { ok, url }
//
// 네트워크 탭에는 사용자 발화·간단한 history 만 보임 (system prompt/스냅샷 노출 없음).

import axios from 'axios'

export async function plan(input, history, imageUrl) {
  const r = await axios.post('/core-api/admin/ai/chat', {
    input,
    history: (history || []).map(m => ({ role: m.role, text: m.text })),
    image_url: imageUrl || null,
  })
  return r.data
}

// 단일 액션 실행 (하위호환)
export async function execute(action, args) {
  const r = await axios.post('/core-api/admin/ai/chat/execute', { action, args })
  return r.data
}

// 다건 액션 일괄 실행. steps = [{ action, args }, ...]
export async function executeBatch(steps) {
  const r = await axios.post('/core-api/admin/ai/chat/execute', {
    actions: (steps || []).map(s => ({ action: s.action, args: s.args })),
  })
  return r.data
}

// 이미지 업로드 → 호스팅 URL 반환
export async function uploadImage(file) {
  const formData = new FormData()
  formData.append('file', file)
  const r = await axios.post('/core-api/admin/ai/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return r.data  // { ok, url, error? }
}
